import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class EventService {
  loadding = new EventEmitter();
}
